module.exports = __webpack_public_path__ + "static/media/bitcoinmorado.c2c2fc8f.svg";